import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

// Reorders the board's columns. Each category lane (Boards::BoardComponent#lanes) gets its own
// Sortable, so a column only moves within its category; changing a status's category, name or
// colour happens on the settings page, which confirms the tasks a category change affects.
export default class extends Controller {
  static targets = ["columnsContainer", "lane", "column"]
  static values = { reorderUrl: String }

  laneTargetConnected(lane) {
    if (!lane.querySelector("[data-column-handle]")) return

    lane.sortable = new Sortable(lane, {
      draggable: '[data-board-columns-target="column"]',
      handle: "[data-column-handle]",
      animation: 250,
      ghostClass: "opacity-50",
      onEnd: this.handleReorder.bind(this),
    })
  }

  laneTargetDisconnected(lane) {
    lane.sortable?.destroy()
    delete lane.sortable
  }

  // Positions run across the whole board in lane order, so the stored order matches what the
  // board shows.
  handleReorder() {
    const positions = this.columnTargets
      .map((column) => parseInt(column.dataset.columnId))
      .filter((id) => id)
      .map((id, index) => ({ id, position: index + 1 }))

    const token = document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({ positions }),
    })
  }
}
